import { useState } from 'react';
import styles from './playlist.module.css';
import Tracklist from './Tracklist';

function Playlist(props) {
  const [name, setName] = useState('');

  const handleChange = (event) => {
    const newName = event.target.value;
    setName(newName);    
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (name === '') {
      alert('Please enter a playlist name.');
      return;
    }

    if (props.tracks.length === 0) {
      alert('Please add songs to the playlist.');
      return;
    }

    props.savePlaylist(name, props.getURIs());
  };

  const handleClear = () => {
    props.resetPlaylist();
    setName('');
  }

  return (
    <div className={styles.Playlist} >
        <form onSubmit={handleSubmit} >
            <input 
              placeholder='New Playlist'
              onChange={handleChange}
              className={styles.PlaylistInput}
              value={name}/>
            <button action="submit" className={styles.SaveButton }>Save Playlist to Spotify</button>
            <button onClick={handleClear} type="button" >Clear Playlist</button>
        </form>
        <div className={styles.PlaylistSongs}>
          <Tracklist tracks={props.tracks} isRemove={true} onRemove={props.onRemove} />
        </div>        
    </div>
  );
}

export default Playlist;
